exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n * Copyright (C) Ethical Recruitment Solutions LLP - All Rights Reserved \n * Unauthorized copying of this file, via any medium is strictly prohibited \n * Proprietary and confidential \n * Written by Thomas Hewett <tom.l.hewett@gmail.com>, Jan 2019\n * ========================================================================\n */\n\n.visible.transition\n{\n    margin-top: auto !important;\n    display: inline-block !important;\n    position: relative;\n    top: 20%;\n}\n\n@media screen and (min-width: 768px) and (max-width: 1199px) {\n    .ui.large.vertical.menu\n    {\n        width: auto;\n    }\n}", ""]);

// exports
